<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
        <div class="my-1">
          <strong> {{$route.params.name}}</strong>
        </div>
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد بررسی آیتم های خدمات
        </b-button>
      </b-col>
    </b-row>
    <div v-if="countries">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage"  />
        <!-- <search ref="countriesSearchComponent" class="w-50" v-model="searchInput" /> -->
      </div>

      <b-card body-class="p-0" class="mt-1">
        <table-head ref="countriesTableHeadComponent" :items="tableHeadings" @sort="sort" />
        <b-row
            class="py-1 mx-1 border-bottom"
            v-for="country in countries"
            :key="country.id"
        >
          <b-col class="d-flex justify-content-between"  v-if="country.serviceable_type==='App\\Models\\'+($route.params.type).charAt(0).toUpperCase()+ ($route.params.type).slice(1)
          &&
          country.serviceable_id==$route.params.id
           ">
            <b-col class="d-flex align-items-center pl-0">
              {{ country.id }}

            </b-col>
            <b-col class="d-flex align-items-center pl-0">
              {{ country.description }}
            </b-col>
            <b-col class="d-flex align-items-center pl-0">
              {{ country.status }}
            </b-col>
            <b-col class="d-flex align-items-center pl-0">
              {{ country.progress }} درصد
            </b-col>
            <b-col class="d-flex align-items-center">
              <b-button
                  @click="showConfirmModal(country)"
                  variant="flat-danger"
                  class="font-weight-bolder"
              >
                <feather-icon icon="Trash2Icon" size="20" />
              </b-button>
              <b-button
                  @click="showFormModal(country)"
                  variant="flat-secondary"
                  class="font-weight-bolder"
              >
                <feather-icon icon="Edit2Icon" size="20" />
              </b-button>
            </b-col>
          </b-col>

        </b-row>
      </b-card>
      <pagination ref="countriesPaginationComponent" v-model="page" :paginationData="paginationData" />
    </div>
    <b-sidebar
        width="580px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش آیتم" : "ایجاد آیتم" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
        <b-form-group class="mt-3">
          <label for="country_name" class="text-capitalize"
          >توضیحات در مورد نواقص خدمات
            :</label
          >
          <b-form-textarea
              id="country_name"
              v-model="checkItemInput.description"
              placeholder="توضیحات"
              rows="3"
          />
        </b-form-group>
        <div class="slidecontainer">
          <input type="range" min="1" max="100" v-model="checkItemInput.progress" class="slider" id="myRange">
          <p> درصد پیشرفت ثبت خدمات : {{checkItemInput.progress}} </p>
        </div>

        <b-form-group>
          <label for="residence_area" class="text-capitalize">
            وضعیت تکمیلی خدمات .<span class="text-danger">*</span>
          </label>
          <div>
            <div><strong> incomplete :  </strong> ناقص </div>
            <div><strong> complete :  </strong> کامل شده </div>
          </div>
          <v-select
              id="residence_area"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="checkItemInput.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="typeStatus"
          />
        </b-form-group>

      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio, BFormRating,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";

export default {
  components: {
    BFormRating,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio
  },
  data() {
    return {
      perPage: 10,
      page: 1,
      countries: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "id",
          slug: "id",
          sortable: true,
        },
        {
          title: "توضیحات",
          sortable: false,
        },
        {
          title: "وضعیت",
          sortable: false,
        },
        {
          title: "پیشرفت",
          sortable: false,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      checkItemInput: {
        id:"",
        serviceable_table: this.$route.params.type,
        serviceable_id:this.$route.params.id,
        description:"",
        progress:50,
        status:""

      },
      typeStatus: [
        "incomplete",
        "complete",
      ],
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getCounties();
    // this.getCompanies();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getCounties();
    },
    perPage(value) {
      this.page = 1;
      this.getCounties();
    },
    page(value) {
      this.getCounties();
    },
  },
  methods: {
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getCounties();
    },

    async getCounties() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate:true,
        //  this.searchInput,
        // per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/checkItems",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.countries = data.data;
            this.paginationData = data.meta;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    showConfirmModal(country) {
      this.$bvModal
          .msgBoxConfirm(
              "آیا از حذف آیتم مطمئن هستید ؟" +
              `: ${country.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let countryIndex = 0;
              this.countries = await this.countries.filter((countryItem, index) => {
                if (countryItem.id == country.id) {
                  countryIndex = index;
                }
                return countryItem.id !== country.id;
              });

              const requestData = {
                method: "delete",
                url: `/admin/checkItems/${country.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `آیتم: ${country.name} با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.countries.splice(countryIndex, 0, country);
                  });
            }
          });
    },
    showFormModal(country) {
      if (country) {
        this.checkItemInput = {
          id: country.id,
          serviceable_id: country.serviceable_id,
          serviceable_table: this.$route.params.type,
          description: country.description,
          progress:country.progress,
          status:country.status,

        };
        this.editMode = true;
      } else {
        this.checkItemInput = {
          description: "",
          serviceable_table: this.$route.params.type,
          serviceable_id:this.$route.params.id,
          progress:"",
          status:"",

        };
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;

      if (!errorMessage && !this.checkItemInput.description) {
        errorMessage = "لطفا توضیحات آیتم را وارد کنید";
      }



      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode ? `/admin/checkItems/${this.checkItemInput.id}` : `/admin/checkItems`,
        data: this.checkItemInput,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "آیتم با موفقیت اضافه شد";
            if (this.editMode) message = "آیتم با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            if (!this.editMode && this.countries && this.countries.length > 0) {
              this.$refs.countriesPaginationComponent.clear();
              // this.$refs.countriesSearchComponent.clear();
              this.$refs.countriesTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }

            this.submitLoading = false;
            this.formModal = false;
            this.getCounties();
          })
          .catch((err) => {
            let message = "خطا در ایجاد آیتم";
            if (this.editMode) message = "خطا در ویرایش آیتم";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },


  },


};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.slidecontainer {
  width: 100%;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #04AA6D;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #04AA6D;
  cursor: pointer;
}
</style>
